import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../services/axiosConfig";

const CompletedRound = ({ pot }) => {
  const [winners, setWinners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!pot?.id) return;
    const fetchWinners = async () => {
      try {
        const res = await axios.get(`${baseURL}/pot/potwinners?pot=${pot.id}`);
        setWinners(res?.data?.data?.players || []);
      } catch {
        setWinners([]);
      } finally {
        setLoading(false);
      }
    };
    fetchWinners();
  }, [pot?.id]);

  return (
    <div className="mt-3 pt-3 border-t border-gray-200">
      <p className="text-sm font-semibold text-[#181818] font-archivo mb-2">
        Winners
      </p>
      {loading ? (
        <p className="text-xs text-gray-400">Loading winners...</p>
      ) : winners.length === 0 ? (
        <p className="text-xs text-gray-400">No winners recorded</p>
      ) : (
        <div className="flex flex-col gap-1">
          {winners.map((w) => (
            <div
              key={w.pick_id}
              className="flex justify-between items-center text-xs font-archivo"
            >
              <span className="text-[#181818] font-medium">{w.username}</span>
              <span className="text-[#0081F8] font-semibold">
                {w.pot_currency} {Number(w.winning_amounts).toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CompletedRound;
